export default __webpack_public_path__ + "images/0x840195888db4d6a99ed9f73fcd3b225bb3cb1a79.png";